(function () {
  'use strict';

  angular.module('app').service('ProviderModalService', ProviderModalService);

  ProviderModalService.$inject = ['ModalService'];

  function ProviderModalService(ModalService) {
    var service = {
      openProviderFastCreateModal: openProviderFastCreateModal,
    };

    return service;

    ////////////////////////////

    function openProviderFastCreateModal(item, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/providers/modals/provider-fast-create-modal.html',
        controller: ProviderFastCreateModalCtrl,
        controllerAs: 'vm',
        inputs: {
          item: item,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        var preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      TourListsModalCtrl.$inject = ['$element', 'item', 'successCallback'];
    }

    function ProviderFastCreateModalCtrl($element, item, successCallback) {
      var vm = this;

      vm.item = item;

      vm.modalTitle = 'NEW_PROVIDER';
      if (vm.item.id) {
        vm.modalTitle = 'EDIT_PROVIDER';
      }

      // Methods
      vm.onSavedItem = onSavedItem;
      vm.onCanceledItem = onCanceledItem;

      function onSavedItem(item) {
        $element.modal('hide');
        successCallback(item);
      }

      function onCanceledItem() {
        $element.modal('hide');
      }
    }
  }
})();
